import React from 'react';
import { motion } from 'framer-motion';
import { PillIcon, SaladIcon, HomeIcon } from 'lucide-react';
const reasons = [{
  icon: PillIcon,
  title: 'Los suplementos caros no funcionan',
  description: 'si tus receptores celulares están bloqueados por bisfenoles y plásticos.',
  bg: 'bg-blush-soft',
  iconBg: 'bg-blush',
  iconColor: 'text-blush-ink'
}, {
  icon: SaladIcon,
  title: 'Comer sano pierde su efecto',
  description: 'si cocinas en sartenes que liberan partículas tóxicas en cada comida.',
  bg: 'bg-sage-soft',
  iconBg: 'bg-sage',
  iconColor: 'text-sage-ink'
}, {
  icon: HomeIcon,
  title: 'Ignorar el entorno doméstico',
  description: 'significa que dejas la causa raíz activa las 24 horas del día en tu propia casa.',
  bg: 'bg-sky-soft',
  iconBg: 'bg-sky-pastel',
  iconColor: 'text-sky-ink'
}];
export function WhyFailed() {
  return <section className="w-full bg-sky-soft py-20 md:py-28" data-id="element-221">
      <div className="max-w-6xl mx-auto px-6 md:px-8" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center mb-14" data-id="element-223">
          <span className="inline-block bg-white text-sky-ink text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-4" data-id="element-224">
            La verdad incómoda
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-ink" data-id="element-225">
            Por qué lo que intentaste no funcionó
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-226">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut',
          delay: index * 0.1
        }} className={`${reason.bg} p-8 rounded-2xl border border-white/60`} data-id="element-227">
              <div className={`inline-flex items-center justify-center w-14 h-14 rounded-full ${reason.iconBg} mb-5`} data-id="element-228">
                <reason.icon className={`w-7 h-7 ${reason.iconColor}`} data-id="element-229" />
              </div>
              <h3 className="font-serif text-xl text-ink mb-3" data-id="element-230">
                {reason.title}
              </h3>
              <p className="text-ink-soft leading-relaxed" data-id="element-231">
                {reason.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}